import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Mask Off" link="/maskoff" bg="linear-gradient(to right, #811d1b 0%, #191919 100%)" mdxType="ProjectCard">
  Game made for the 2026 Global Game Jam
    </ProjectCard>
    <ProjectCard title="Hydrogen Luminess" link="/hydrogenLuminess" bg="linear-gradient(to right, #009245 0%, #fcee21 100%)" mdxType="ProjectCard">
  VR scenario made while working at Luminess.
    </ProjectCard>
    <ProjectCard title="Card Game" link="/cardGame" bg="linear-gradient(to right, #5d00ff 0%, #00ffb8 100%)" mdxType="ProjectCard">
  Collectible card game with heavy RPG elements played on a randomly generated board.
    </ProjectCard>
    <ProjectCard title="Time Raiders" link="/timeraiders" bg="linear-gradient(to right, #662d8c 0%, #095aff 100%)" mdxType="ProjectCard">
  Fast-paced shoot and loot, time travel game.
    </ProjectCard>
    <ProjectCard title="Exposure Therapy VR" link="/phobia" bg="linear-gradient(to right, #095aff 0%, #00ffb8 100%)" mdxType="ProjectCard">
  My Master's thesis, a VR application meant to treat people suffering from Acrophobia.
    </ProjectCard>
    <ProjectCard title="Bachelor's Thesis" link="/bachelor" bg="linear-gradient(to right, #fa00ff 0%, #fff700 100%)" mdxType="ProjectCard">
  The project I have developed and presented as my Bacherlor's thesis. An application used for text generation.
    </ProjectCard>
    <ProjectCard title="UE5 Udemy Course" link="/slash" bg="linear-gradient(to right, #ff5733 0%, #ffb7a8 100%)" mdxType="ProjectCard">
  RPG made in Unreal Engine 5.2, based on a Udemy course.
    </ProjectCard>
    <ProjectCard title="Solitaire Expert" link="/solitaireexpert" bg="linear-gradient(to right, #009245 0%, #fcee21 100%)" mdxType="ProjectCard">
  A variant of the classic solitaire game.
    </ProjectCard>
    <ProjectCard title="Music Platformer" link="/musicplatformer" bg="linear-gradient(to right, #662d8c 0%, #ed1e79 100%)" mdxType="ProjectCard">
  A 2.5D music-based puzzle platformer.
    </ProjectCard>
    <ProjectCard title="5 Minute Hero" link="/minutehero" bg="linear-gradient(to right, #d585ff 0%, #00ffee 100%)" mdxType="ProjectCard">
  This is a Unity 2D game created for a fund-raising game jam held in Romania. 
    </ProjectCard>
    <ProjectCard title="Music and Fractals" link="/musicfractals" bg="linear-gradient(to right, #5d00ff 0%, #00ff1f 100%)" mdxType="ProjectCard">
  A project which creates fractals based on the music playing in the background. <b>(!Flashing colours warning!)</b>
    </ProjectCard>
    <ProjectCard title="Dragon RPG" link="/dragonrpg" bg="linear-gradient(to right, #ff0000 0%, #ffc800 100%)" mdxType="ProjectCard">
  A Unity RPG game made following a Udemy course.
    </ProjectCard>
    <ProjectCard title="Turn Based Combat" link="/turncombat" bg="linear-gradient(to right, #279000 0%, #007eff 100%)" mdxType="ProjectCard">
  Phaser multiplayer game made following a course.
    </ProjectCard>
    <ProjectCard title="Footmen Project" link="/footmen" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  The game is supposed to be a combination between Auto-Chess, a MOBA and Footmen Frenzy.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      